export default {"src":"/_next/static/media/open_app.9ca7c89c.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};